import React, { useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';
import { isoStandard } from '../../../core/helpers/isoStandard';
import { userInfoStore } from '../../../store/userInfoStore';
import { applicationStore } from '../../../store/applicationStore';
import TextOrderingByWidth from '../../../components/common/textOrderingByWidth';

const BalanceWrapper = observer(() => {
  const { balance, currencySymbol, currencyIcon, isReplay } = userInfoStore;
  const balanceContainerRef = useRef();
  const { isShowLicenseMode, isDemo } = applicationStore;

  const balanceWithIsoStandard = useMemo(() => {
    return isoStandard(balance, true);
  }, [balance]);

  const { containerConfig, texts } = useMemo(() => {
    return {
      containerConfig: {
        y: isMobile() ? 20 : 48,
        x: isMobile() ? 260 : 110,
        ref: balanceContainerRef,
      },
      texts: [
        {
          id: 0,
          text: applicationStore.canvasTranslationKeys.BALANCE,
          style: { fill: '#FFC33E', fontSize: 14, fontWeight: 500, fontFamily: 'poppinsMedium' },
          anchor: { x: 0, y: 0.5 },
          resolution: 2,
          ref: null,
        },
        {
          id: 1,
          text: isReplay ? '' : `${balanceWithIsoStandard}`,
          style: { fill: '#FFFFFF', fontSize: 16, fontWeight: 700, fontFamily: 'poppinsMedium' },
          anchor: { y: 0.5 },
          resolution: 2,
          ref: null,
        },
        {
          id: 2,
          text: isReplay ? '' : isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol,
          style: {
            fill: '#FFFFFF',
            fontSize: isShowLicenseMode && !isDemo ? 16 : 10,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
          },
          anchor: { y: 0.5 },
          resolution: 2,
          ref: null,
          y: 1,
        },
      ],
    };
  }, [balanceWithIsoStandard, currencySymbol, currencyIcon, isShowLicenseMode, isDemo, isReplay]);

  const updateTextByLicense = useMemo(() => {
    return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
  }, [isShowLicenseMode, isDemo, texts]);

  return (
    <Container {...containerConfig}>
      <TextOrderingByWidth texts={updateTextByLicense} isCenter={isMobile()} space={3} />
    </Container>
  );
});
export default BalanceWrapper;
